<div [(ngpTabsetValue)]="selectedTab" ngpTabset ngpTabsetOrientation="vertical">
  <div class="my-profile-tabs flex">
    <h4 class="typography-small-title font-bold">Admin: User Profile</h4>
    <div ngpTabList>
      @for (tab of tabs; track tab.key) {
      <button
        ngpTabButton
        [ngpTabButtonValue]="tab.key"
        class="my-profile-tab button rounded-4 button--style-primary button--style-primary-bordered-2 h-38"
      >
        <svg-icon
          class="s-12 flex items-center justify-center"
          [src]="tab.icon"
        ></svg-icon>
        <span>{{ tab.label }}</span>
      </button>
      }
    </div>
  </div>
  <app-admin-user-profile
    animate.enter="animate-fade-in"
    class="flex flex-col gap-16"
    ngpTabPanel
    ngpTabPanelValue="profile"
    [user]="user()"
    [hidePrimaryData]="hidePrimaryData()"
  >
  </app-admin-user-profile>
  @if (selectedTab() === 'games-history') {
  <app-user-games-history
    animate.enter="animate-fade-in"
    ngpTabPanel
    ngpTabPanelValue="games-history"
    class="flex flex-col gap-16"
    [user]="user()"
    [pagination]="{
    pageIndex: 0,
    pageSize: 15,
  }"
  ></app-user-games-history>
  } @else if (selectedTab() === 'transactions-history') {
  <app-user-transactions-history
    animate.enter="animate-fade-in"
    ngpTabPanel
    ngpTabPanelValue="transactions-history"
    class="flex flex-col gap-16"
    [user]="user()"
    [pagination]="{
    pageIndex: 0,
    pageSize: 15,
  }"
  ></app-user-transactions-history>
  } @else if (selectedTab() === 'tickets') {
  <app-admin-user-tickets-table
    animate.enter="animate-fade-in"
    ngpTabPanel
    ngpTabPanelValue="tickets"
    class="flex flex-col gap-16"
    [user]="user()"
    [pagination]="{
  pageIndex: 0,
  pageSize: 15,
}"
  ></app-admin-user-tickets-table>
  }
</div>
